<template>
  <div>
    <h1 class="text-center" style="padding-top: 36px; padding-bottom: 36px; font-size: 36px; font-weight: 700">안전보건교육일지</h1>
    <table>
      <tbody>
        <tr>
          <td rowspan="2" class="title border-top border-left text-left p-8">
            <h1 style="font-size: 32px; font-weight: 700; margin-bottom: 16px">경 상 남 도</h1>
            <div style="font-size: 16px; font-weight: 400">부서명 : {{ form.stdInfo.field_name }}</div>
          </td>
          <td rowspan="2" class="titleCell bordered" style="width: 33px; border-bottom: 0">결<br /><br /><br />재</td>
          <td class="titleCell signTitle bordered">작성자</td>
          <td class="titleCell signTitle bordered">검토자</td>
          <td class="titleCell signTitle bordered">회람자</td>
          <td class="titleCell signTitle bordered">승인자</td>
        </tr>
        <tr>
          <td class="signBody bordered">
            <div style="height: 80px">
              <img v-if="!!form.sign1.sign" :src="form.sign1.sign" class="w-full h-full object-contain" />
            </div>
          </td>
          <td class="signBody bordered">
            <div style="height: 80px">
              <img v-if="!!form.sign2.sign" :src="form.sign2.sign" class="w-full h-full object-contain" />
            </div>
          </td>
          <td class="signBody bordered">
            <div style="height: 80px">
              <img v-if="!!form.sign3.sign" :src="form.sign3.sign" class="w-full h-full object-contain" />
            </div>
          </td>
          <td class="signBody bordered">
            <div style="height: 80px">
              <img v-if="!!form.sign4.sign" :src="form.sign4.sign" class="w-full h-full object-contain" />
            </div>
          </td>
        </tr>
      </tbody>
    </table>
    <table class="contentTable" style="page-break-after: always">
      <colgroup>
        <col width="180" />
        <col width="926" />
      </colgroup>
      <tbody>
        <tr>
          <td class="titleCell">교육과정</td>
          <td>
            <div style="white-space: pre-wrap">{{ !!form.inputA_1 ? form.inputA_1.value : "" }}</div>
            <p class="mt-4">※ 교육과정 및 교육대상별 교육시간은 산업안전보건법 시행규칙[별표4] 참조</p>
          </td>
        </tr>
        <tr>
          <td class="titleCell">교육일시</td>
          <td class="text-center" style="font-size: 16px">{{ 교육일시 }}</td>
        </tr>
        <tr>
          <td class="titleCell">교육강사<br />및 장소</td>
          <td class="p-0">
            <table>
              <tr>
                <th class="titleCell" style="padding-top: 0.5rem; padding-bottom: 0.5rem; border-right: solid 1px #cdcdcd">직책</th>
                <th class="titleCell" style="padding-top: 0.5rem; padding-bottom: 0.5rem; border-right: solid 1px #cdcdcd">성명</th>
                <th class="titleCell" style="padding-top: 0.5rem; padding-bottom: 0.5rem; border-right: solid 1px #cdcdcd">교육장소</th>
                <th class="titleCell" style="padding-top: 0.5rem; padding-bottom: 0.5rem">비고</th>
              </tr>
              <tr>
                <td class="text-center" style="border-left: none; border-bottom: none">{{ form.inputA_11 }}</td>
                <td class="text-center" style="border-bottom: none">{{ form.inputA_9 }}</td>
                <td class="text-center" style="border-bottom: none">{{ form.inputA_7 }}</td>
                <td class="text-center" style="border-right: none; border-bottom: none">{{ form.비고 }}</td>
              </tr>
            </table>
          </td>
        </tr>
        <tr>
          <td class="titleCell">교육방법</td>
          <td class="text-center" style="font-size: 16px">
            <div style="display: flex; align-items: center">
              <span class="print-checkbox"
                ><i class="mr-2"><feather-icon svgClasses="w-4 w-5" icon="CheckIcon" /></i> 강의식</span
              >
              <span class="print-checkbox ml-4"
                ><i class="mr-2"><feather-icon svgClasses="w-4 w-5" icon="CheckIcon" /></i> 토의식</span
              >
              <span class="print-checkbox ml-4"
                ><i class="mr-2"><feather-icon svgClasses="w-4 w-5" icon="CheckIcon" /></i> 체험식</span
              >
              <span class="print-checkbox ml-4"
                ><i class="mr-2"><feather-icon svgClasses="w-4 w-5" icon="CheckIcon" /></i> 시청각</span
              >
            </div>
          </td>
        </tr>
        <tr>
          <td class="titleCell">교육인원</td>
          <td class="p-0">
            <table>
              <tr>
                <th class="p-2 titleCell border-right border-bottom">구분</th>
                <th class="p-2 titleCell border-right">계</th>
                <th class="p-2 titleCell border-right">남</th>
                <th class="p-2 titleCell border-right">여</th>
                <th class="p-2 titleCell">교육 미참석 사유</th>
              </tr>
              <tr>
                <th class="p-2 titleCell border-bottom">교육 대상자 수</th>
                <td class="p-2 text-center">{{ getTotal대상자수 }}</td>
                <td class="p-2 text-center">{{ form.대상자수_남 }}</td>
                <td class="p-2 text-center">{{ form.대상자수_여 }}</td>
                <td class="p-2 text-center" style="border-right: none">{{ form.대상자수_미참석사유 }}</td>
              </tr>
              <tr>
                <th class="p-2 titleCell border-bottom">교육 이수자 수</th>
                <td class="p-2 text-center">{{ getTotal이수자수 }}</td>
                <td class="p-2 text-center">{{ form.이수자수_남 }}</td>
                <td class="p-2 text-center">{{ form.이수자수_여 }}</td>
                <td class="p-2 text-center" style="border-right: none">{{ form.이수자수_미참석사유 }}</td>
              </tr>
              <tr>
                <th class="p-2 titleCell">교육 미이수자 수</th>
                <td class="p-2 text-center" style="border-bottom: none">{{ getTotal미이수자수 }}</td>
                <td class="p-2 text-center" style="border-bottom: none">{{ form.미이수자수_남 }}</td>
                <td class="p-2 text-center" style="border-bottom: none">{{ form.미이수자수_여 }}</td>
                <td class="p-2 text-center" style="border-bottom: none; border-right: none">{{ form.미이수자수_미참석사유 }}</td>
              </tr>
            </table>
          </td>
        </tr>
        <tr>
          <td class="titleCell">교육제목</td>
          <td>{{ form.inputA_3 }}</td>
        </tr>
        <tr>
          <td class="titleCell">교육내용</td>
          <td>
            <div style="white-space: pre-wrap; min-height: 400px">{{ form.inputA_15 }}</div>
          </td>
        </tr>
        <tr class="print-container">
          <td class="titleCell">특이사항</td>
          <td>
            <div style="white-space: pre-wrap; min-height: 160px"></div>
          </td>
        </tr>
      </tbody>
    </table>

    <!-- 사진대지 -->
    <h1 class="titleFull" style="font-size: 36px; font-weight: 700">안전보건교육 사진대지</h1>
    <div
      v-for="photo in form.photoList"
      :key="photo.id"
      v-if="photo.path"
      class="mb-6"
      style="display: grid; grid-template-columns: 1fr 306px; grid-template-rows: 48px 48px 48px 48px 1fr 48px 48px; border-top: 1px solid #cdcdcd; border-left: 1px solid #cdcdcd"
    >
      <div class="border-right border-bottom" style="grid-row: 1 / span 5">
        <div class="photoContainer">
          <img style="width: 100%" :src="photo.path" :alt="photo.input" />
        </div>
      </div>
      <div class="border-right border-bottom" style="display: grid; grid-template-columns: 100px 1fr">
        <span class="h1 border-right"> 일 자 </span>
        <span class="b1"> {{ photo.date }} </span>
      </div>
      <div class="border-right border-bottom" style="display: grid; grid-template-columns: 100px 1fr">
        <span class="h1 border-right"> 시 간 </span>
        <span class="b1"> {{ photo.time }} </span>
      </div>
      <div class="border-right border-bottom" style="display: grid; grid-template-columns: 100px 1fr">
        <span class="h1 border-right"> 참 석 </span>
        <span class="b1"> {{ photo.count }} <span class="ml-auto">명</span></span>
      </div>
      <div class="border-right border-bottom" style="display: grid; grid-template-columns: 100px 1fr">
        <span class="h1 border-right"> 불 참 </span>
        <span class="b1"> {{ photo.uncount }} <span class="ml-auto">명</span></span>
      </div>
      <div class="border-right border-bottom" style="display: grid; grid-template-columns: 100px 1fr">
        <span class="h1 border-right"></span>
        <span class="b1"></span>
      </div>
      <div class="border-right border-bottom" style="grid-column: 1 / span 2; display: grid; grid-template-columns: 100px 1fr">
        <span class="h1 border-right">교 육 장 소</span>
        <span class="b1">{{ photo.address }}</span>
      </div>
      <div class="border-right border-bottom" style="grid-column: 1 / span 2; display: grid; grid-template-columns: 100px 1fr">
        <span class="h1 border-right">교 육 과 정</span>
        <span class="b1">{{ photo.curriculum }}</span>
      </div>
    </div>
    <div style="page-break-before: always"></div>

    <!--참석자 명단-->
    <h1 class="titleFull" style="font-size: 36px; font-weight: 700">안전교육 참석자 명단</h1>
    <div class="grid" style="grid-template-columns: 1fr 1fr">
      <label class="pl-2" style="font-weight: 400; font-size: 16px">
        부서명 : <span class="ml-4">{{ !!form.stdInfo ? form.stdInfo.field_name : "" }}</span>
      </label>
      <label class="pl-2" style="font-weight: 400; font-size: 16px">
        교육일자 : <span class="ml-4">{{ form.inputA_4 }}</span>
      </label>
    </div>

    <table style="margin-top: 12px">
      <tr>
        <td style="width: 50%; padding-right: 5px">
          <table class="attendeeTable">
            <colgroup>
              <col width="64" />
              <col width="164" />
              <col width="164" />
              <col width="164" />
            </colgroup>
            <tbody>
              <tr>
                <td class="titleCell">순번</td>
                <td class="titleCell">부서명(직책)</td>
                <td class="titleCell">성명</td>
                <td class="titleCell">서명</td>
              </tr>
              <tr v-for="index in 20" :key="index">
                <td>{{ index }}</td>
                <td>{{ typeof form.signatureList[index - 1] !== "undefined" ? form.signatureList[index - 1].target : "" }}</td>
                <td>{{ typeof form.signatureList[index - 1] !== "undefined" ? form.signatureList[index - 1].name : "" }}</td>
                <td style="width: 1%; white-space: nowrap; min-width: 90px; padding: 2px">
                  <img v-if="typeof form.signatureList[index - 1] !== 'undefined'" height="50" :src="form.signatureList[index - 1].sign" />
                </td>
              </tr>
            </tbody>
          </table>
        </td>
        <!--<td style="width: 10px;"></td>-->
        <td style="width: 50%; padding-left: 5px">
          <table class="attendeeTable">
            <colgroup>
              <col width="64" />
              <col width="164" />
              <col width="164" />
              <col width="164" />
            </colgroup>
            <tbody>
              <tr>
                <td class="titleCell">순번</td>
                <td class="titleCell">부서명(직책)</td>
                <td class="titleCell">성명</td>
                <td class="titleCell">서명</td>
              </tr>
              <tr v-for="index in 20" :key="index + 20">
                <td>{{ index + 20 }}</td>
                <td>{{ typeof form.signatureList[index + 20 - 1] !== "undefined" ? form.signatureList[index + 20 - 1].target : "" }}</td>
                <td>{{ typeof form.signatureList[index + 20 - 1] !== "undefined" ? form.signatureList[index + 20 - 1].name : "" }}</td>
                <td style="width: 1%; white-space: nowrap; min-width: 90px; padding: 2px">
                  <img v-if="typeof form.signatureList[index + 20 - 1] !== 'undefined'" height="50" :src="form.signatureList[index + 20 - 1].sign" />
                </td>
              </tr>
            </tbody>
          </table>
        </td>
      </tr>
    </table>
  </div>
</template>

<script>
import moment from "moment";
export default {
  name: "Print107",
  props: {
    form: Object,
  },
  filters: {
    comma(val) {
      return String(val).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
  },
  computed: {
    getTotal대상자수() {
      return Number(this.form.대상자수_남) + Number(this.form.대상자수_여);
    },

    getTotal이수자수() {
      return Number(this.form.이수자수_남) + Number(this.form.이수자수_여);
    },

    getTotal미이수자수() {
      return Number(this.form.미이수자수_남) + Number(this.form.미이수자수_여);
    },
    setTime() {
      const times = [];
      const sMoment = moment(this.form.inputA_5, "HH:mm:ss");
      const eMoment = moment(this.form.inputA_6, "HH:mm:ss");

      if (sMoment.isValid()) {
        const sTime = sMoment.format("HH:mm");
        if (sTime) times.push(sTime);
      } else {
        times.push("");
      }

      if (eMoment.isValid()) {
        const eTime = eMoment.format("HH:mm");
        if (eTime) times.push(eTime);
      } else {
        times.push("");
      }

      if (sMoment.isValid() || eMoment.isValid()) {
        return times.join(" ~ ");
      } else {
        return "";
      }
    },
    diffTime() {
      if (!this.form.inputA_5 || !this.form.inputA_6) return "";

      const sTime = moment(this.form.inputA_5, "HH:mm:ss");
      const eTime = moment(this.form.inputA_6, "HH:mm:ss");

      const h = moment.duration(eTime.diff(sTime)).hours();
      const m = moment.duration(eTime.diff(sTime)).minutes();

      const returnStr = [];
      if (h > 0) returnStr.push(`${h}시간`);
      if (m > 0) returnStr.push(`${m}분`);

      if (sTime.isValid() && eTime.isValid()) {
        return returnStr.join(" ");
      } else {
        return "";
      }
    },
    교육일시() {
      // {{ form.inputA_4 }}, {{ setTime }} ({{ diffTime }})
      let result = "";
      if (this.form.inputA_4) {
        result += this.form.inputA_4;
        if (this.setTime) {
          result += `, ${this.setTime}`;
          if (this.diffTime) {
            result += ` (${this.diffTime})`;
          }
        } else if (this.diffTime) {
          result += ` (${this.diffTime})`;
        }
      } else if (this.setTime) {
        result += this.setTime;
        if (this.diffTime) {
          result += ` (${this.diffTime})`;
        }
      } else if (this.diffTime) {
        result += this.diffTime;
      }
      return result;
    }
  },
};
</script>

<style lang="scss" scoped>
$border-color: #cdcdcd;
$approval-border: 2px solid #cdcdcd;
$title-bg-color: #f9f9f9;
.bordered {
  border: 1px solid $border-color;
}
.titleCell {
  background-color: $title-bg-color;
  text-align: center;
  font-weight: 700;
}
.title {
  font-size: 24px;
  font-weight: bold;
  text-align: center;
}
.titleFull {
  font-size: 24px;
  font-weight: bold;
  text-align: center;
  width: 100%;
  height: 110px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}
table {
  width: 100%;
  border-collapse: collapse;
  border-spacing: 0;

  .signTitle {
    width: 125px;
    height: 38px;
  }
  .signBody {
    height: 100px;
    border-bottom: 0;
  }
}
.contentTable {
  td {
    border: 1px solid $border-color;
    padding: 19px 14px;
  }
  .titleCell {
    width: 180px;
    padding: 19px 0;
    font-size: 14px;
  }
}
.label-text {
  width: 114px;
  font-weight: 500;
  font-size: 14px;
}

.attendeeTable {
  td {
    height: 60px;
    border: 1px solid $border-color;
    text-align: center;
  }
}
img {
  -webkit-print-color-adjust: exact;
}
.pageBreak {
  page-break-after: always;
}

.print-radio,
.print-checkbox {
  display: flex;
  align-items: center;

  & > i {
    width: 20px;
    height: 20px;
    border: 2px solid #cdcdcd;
    position: relative;
  }
  & .feather-icon {
    transform: translateY(-4px);
  }
}

.print-radio {
  & > i {
    border-radius: 20px;
  }
}

.photoContainer {
  display: flex;
  justify-content: center;
  width: 100%;
  border-radius: 6px;
  border: dashed 1px $border-color;
}
.b1,
.h1 {
  display: flex;
  align-items: center;
  font-size: 18px;
}
.h1 {
  justify-content: center;
  font-weight: 700;
}
.b1 {
  padding: 8px 16px;
}
</style>
